import { Box, BoxProps, styled } from '@mui/material';
import { ProjectStatus } from '../types/Project';

type StatusLabelOwnProps = {
  status: ProjectStatus | 'online' | 'offline' | 'abnormal';
};

type StatusLabelProps = StatusLabelOwnProps & BoxProps;

const StatusLabel = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'status',
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
})<StatusLabelOwnProps>(({ theme, status }): any => ({
  ...theme.externalTypography.body3Bold,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  color: 'white',
  width: '100px',
  height: '22px',
  background: (() => {
    switch (status) {
      case 'open':
      case 'online':
        return '#78DC00';
      case 'inprogress':
        return theme.color.primary.$80;
      case 'completed':
        return theme.color.secondary.$80;
      case 'overdue':
      case 'abnormal':
        return '#FF6800';
      case 'offline':
        return theme.color.secondary.$40;
      case 'suspend':
        return theme.color.secondary.$100;
      default:
        return theme.color.primary.$80;
    }
  })(),
  padding: '0 8px',
  borderRadius: '4px',
})) as React.ComponentType<StatusLabelProps>;

export default StatusLabel;
